import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {GlobalsService} from '../_services/globals.service';
import { KeycloakService } from './keycloak.service';

@Injectable()
export class LoginService 
{

  constructor(private http: HttpClient,private gs:GlobalsService ,private keycloak:KeycloakService ) 
  { 
      
      
  }

  public login(user: string, pass: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const body = new HttpParams()
      .set('user', user)
      .set('psw', pass);

    return this.http.post<any>(
      `${this.gs.getRestUrl()}/api/login/userlogin`,
      body.toString(),
      { headers, withCredentials: false }
    );
  }

  
  public keycloaklogin(subject: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const appNum = this.isPublic() ? 2 : 1;

    const body = new HttpParams()
      .set('subject', subject)
      .set('appid', appNum.toString());

    return this.http.post<any>(
      `${this.gs.getRestUrl()}/api/login/keycloaklogin`,
      body.toString(),
      { headers, withCredentials: false }
    );
  } 
 
  public loggoff()
  {
     
  }
  
  public  isAuthorisedRole(role:string):boolean
  {
      
      return KeycloakService.auth.authz.hasRealmRole(role);
  }
  
  public  isAuthorisedUserManagment():boolean
  {
      
      return KeycloakService.auth.authz.hasResourceRole("manage-users","realm-management");
  }
  
  public  isPublic():boolean
  {
      
      return KeycloakService.auth.authz.hasRealmRole("public");
  }
  
  public getPermissions(cb:any):any
  {
     this.keycloaklogin(KeycloakService.auth.authz.subject).subscribe(r=>{
          cb(r)
      }); 
  }
  
  public isUserLoged():boolean
  {
      if (KeycloakService.auth.authz.token)
      {
          //console.log("is user loged:"+KeycloakService.auth.authz.token);
          //console.log(KeycloakService.auth.authz);
          return true;
      }
      return false;
  }

}
